export class CartTaxFormValues {
  constructor(public key: string, public tax: Record<string, number>) {}
}
